import Editor from "@monaco-editor/react"

export default function TextContent(props:{text:string}){
    return <Editor defaultValue={props.text}/>
}